import { QRCodeSVG } from 'qrcode.react';
import { toast } from 'react-toastify';
import { FaAndroid, FaApple, FaLink } from 'react-icons/fa';
import { QrBloco, QrItem } from './styles';

interface Props {
    android: string;
    ios: string;
    tamanho?: number;
}

const copiar = (link: string) =>
    navigator.clipboard?.writeText(link).then(() => toast.success('Link copiado. Envie para o seu cliente.')).catch(() => undefined);

// QR code de cada loja, com o link para copiar (para mandar ao cliente pelo WhatsApp, por exemplo).
export default function QrLojas({ android, ios, tamanho = 116 }: Props) {
    return (
        <QrBloco>
            {[{ link: android, rotulo: 'Android', Icone: FaAndroid }, { link: ios, rotulo: 'iPhone', Icone: FaApple }].map(({ link, rotulo, Icone }) => (
                <QrItem key={rotulo}>
                    <a href={link} target="_blank" rel="noopener noreferrer">
                        <QRCodeSVG value={link} size={tamanho} fgColor="#212529" />
                        <span><Icone /> {rotulo}</span>
                    </a>
                    <button type="button" onClick={() => copiar(link)}><FaLink /> Copiar link</button>
                </QrItem>
            ))}
        </QrBloco>
    );
}
